var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"services-banner",style:(`background-image: url(${_vm.bgSrc})`)},[_c('div',{staticClass:"services-banner__content"},[_c('h2',{staticClass:"services-banner__icon"},[_c('img',{attrs:{"src":_vm.iconSrc,"alt":"icon"}})]),_c('p',{staticClass:"services-banner__desc"},[_vm._v(_vm._s(_vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }